import request from '@/utils/request'
// get options
export function getCheckoutGroup() {
  return request({
    url: '/cashier-service/v1/checkout-group',
    method: 'get'
  })
}
// get list
export function getCheckoutGroupList(id) {
  return request({
    url: `/cashier-service/v1/checkout-group/${id}`,
    method: 'get'
  })
}
// set master
export function checkoutGroupMaster(params) {
  return request({
    url: '/cashier-service/v1/checkout-group/master',
    method: 'put',
    params: params
  })
}
// check out group
export function checkoutGroup(id) {
  return request({
    url: `/cashier-service/v1/checkout-group/${id}`,
    method: 'get'
  })
}
// edit checkout group
export function editCheckoutGroup(data) {
  return request({
    url: '/cashier-service/v1/checkout-group',
    method: 'put',
    data: data
  })
}

export function downloadGroupCheckoutList(query) {
  return request({
    url: '/cashier-service/v1/checkout-group/export-excel',
    method: 'get',
    params: query,
    responseType: 'arraybuffer'
  })
}

// export function getTranPageById(params) {
//   return request({
//     url: `/cashier-service/v1/room-transaction/transfer/${params.id}`,
//     method: 'get'
//   })
// }

// export function getTransactionByPage(params) {
//   return request({
//     url: `/cashier-service/v1/room-transaction/booking/${params.id}`,
//     method: 'get',
//     params: params
//   })
// }

// export function cancelTransaction(params) {
//   return request({
//     url: `/cashier-service/v1/room-transaction/cancel/${params.id}`,
//     method: 'post',
//     params: params
//   })
// }

// export function cancelCheckoutCustomer(params) {
//   return request({
//     url: `/cashier-service/v1/room-transaction/checkout/cancel/${params.id}`,
//     method: 'put'
//   })
// }

// export function splitTransaction(params) {
//   return request({
//     url: `/cashier-service/v1/room-transaction/split/${params.id}`,
//     method: 'post',
//     params: params
//   })
// }
// export function getMenuChildApi(query) {
//   return request({
//     url: '/auth-service/v1/menu-child',
//     method: 'get',
//     params: query
//   })
// }
